import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { strings } from '@constants'
import { updateOrganisationApi } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button, Select } from '@baseV2'

import { InputsWrapper } from '../styles'

const _modeType = [{ name: 'CASH' }]

const PaymentModeForm = ({ update, financialData, orgId }) => {
	const dispatch = useDispatch()
	const [paymentMode, setPaymentMode] = useState({})

	useEffect(() => {
		if (financialData?.payment_mode) {
			setPaymentMode(_modeType?.find((item) => item?.name === financialData?.payment_mode) || {})
		}
	}, [financialData])

	const buttonHandler = () => {
		dispatch(showLoader(true))
		updateOrganisationApi(orgId, 'PAYMENT_MODE', paymentMode?.name)
			.then(() => {
				update()
				dispatch(toggleDrawer(false))
				dispatch(showToast(true, strings('msg_payment_update'), { type: TOAST_TYPE.SUCCESS }))
			})
			.catch((err) => console.log(err))
			.finally(() => dispatch(showLoader(false)))
	}

	return (
		<>
			<DrawerBodyWrapper>
				<InputsWrapper>
					<Select
						id='payment-mode-v2'
						label={strings(['select', 'mode', 'type'])}
						placeholder={strings(['select', 'mode', 'type'])}
						data={_modeType}
						displayKey='name'
						primaryKey='name'
						value={paymentMode ?? {}}
						onChange={setPaymentMode}
					/>
				</InputsWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button color='primary' onClick={buttonHandler}>
					{strings('update')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default PaymentModeForm
